<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="card-header">
              <h4 class="card-title">
                <em class="now-ui-icons loader_refresh spin"></em>
                ระบบอัตโนมัติกำลังรอให้ท่านโอนเงินเข้ามา..
              </h4>
            </div>
          </div>
        </div>
        <hr />

        <div class="card-body" v-if="data !== null">
          <div class="row">
            <div class="col-md-6 text-center">
              <card class="card-tasks" no-footer-line>
                <template v-slot:header>
                  <h5 class="title">จำนวนเงินที่ต้องโอน</h5>
                </template>
                <h4
                  class="card-title"
                  style="margin-top: 0px; font-size: 2.5em"
                >
                  {{ this.data.price }}.{{
                    this.data.point.toString().padStart(2, "0")
                  }}
                </h4>
              </card>
              <card class="card-tasks" no-footer-line>
                <template v-slot:header>
                  <h5 class="title">ภายในเวลา</h5>
                </template>
                <h4
                  class="card-title"
                  style="margin-top: 0px; font-size: 2.5em"
                >
                  {{ this.timers }}
                </h4>
              </card>
            </div>
            <div class="col-md-6">
              <card
                class="card-testimonial"
                no-footer-line
                header-classes="card-header-avatar"
              >
                <template v-slot:header>
                  <img
                    class="img img-raised"
                    alt=""
                    v-bind:src="this.gamePackage.bank.logo"
                  />
                </template>

                <p class="card-description">
                  ธ. {{ this.gamePackage.bank.bankName }}
                </p>
                <p class="card-description">
                  ชื่อบัญชี {{ this.gamePackage.bank.accountName }}
                </p>

                <h4 class="card-title">
                  {{ this.gamePackage.bank.accountNo }}
                </h4>
                <p class="category">ใช้สำหรับซื้อสินค้าบนเว็บไซต์เท่านั้น</p>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <br />
              <ui>
                <li class="text-muted">
                  <span class="text-danger"
                    ><strong>ทศนิยมต้องตรง ห้ามปัดเศษเด็ดขาด</strong></span
                  >
                  ระบบตรวจสอบยอดของท่านจากเศษทศนิยม
                  หากทศนิยมไม่ตรงระบบจะไม่ทราบว่าท่านได้โอนเข้ามาแล้ว
                </li>
                <!-- <li class="text-muted">
                  รหัสบัตรจะส่งให้โดยอัตโนมัติ ภายใน 1-5 นาที
                  หลังชำระเงินสมบูรณ์
                </li> -->
                <li class="text-muted">
                  สามารถโอนเงินได้ทุกช่องทางทั้งคอมและมือถือ (ทศนิยมต้องตรง)
                </li>
                <li class="text-muted">
                  ท่านสามารถปิดหรือรีเฟรชหน้านี้ได้ โดยไม่ส่งผลกระทบต่อระบบ
                </li>
              </ui>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <hr />
          <div class="text-center">
            <h5 class="text-muted">หลังจากโอนเงินแล้วให้กดปุ่มยืนยัน</h5>
          </div>
          <div class="row text-center">
            <div
              class="
                col-xxxl-4
                col-xxl-4
                col-xl-4
                col-lgg-6
                col-lg-6
                col-md-6
                col-sm-6
                col-xs-8
                mr-auto
                ml-auto
              "
            >
              <n-button class="btn-outline-info" @click="cancelOrder">
                <span class="btn-label"
                  ><em class="now-ui-icons ui-1_simple-remove"></em
                ></span>
                ยกเลิกคำสั่งซื้อ</n-button
              >
              &nbsp;
              <n-button
                type="primary"
                style="color: #5d5d5d !important"
                @click="nextStep"
              >
                <span class="btn-label"></span>
                ยินยัน</n-button
              >
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { message } from "ant-design-vue";
import * as configuration from "../../middleware/configuration";
import * as paymentservice from "../../services/payment";

export default {
  methods: {
    onTermsChange(value) {
      this.checkboxes.terms = value.terms;
      this.checkboxes.terms2 = value.terms2;
    },
    nextStep() {
      localStorage.setItem("IsConfirm", true);
      this.$router.push("/thankyou");
    },
    async confirmOrder() {
      let uid = await configuration.getUid();
      var data = {
        RandPointId: 0,
        GameId: parseInt(this.gamePackage.gameId),
        PackageId: parseInt(this.gamePackage.package.id),
        PlayerId: this.gamePackage.playerId,
        PlayerName: this.gamePackage.playerName,
        Field1: this.gamePackage.field1,
        Field2: this.gamePackage.field2,
        Field3: this.gamePackage.field3,
        Field4: this.gamePackage.field4,
        Field5: this.gamePackage.field5,
        Uid: uid,
        PaymentMethodName: this.gamePackage.paymentMethod.name,
        PaymentMethodCode: this.gamePackage.paymentMethod.code,
        BankName: this.gamePackage.bank.bankName,
        BankAccount: this.gamePackage.bank.accountNo,
      };

      try {
        let res = await paymentservice.confirmOrder(data);
        this.data = res.data;
        const datares = JSON.stringify(res.data);
        localStorage.setItem("data", datares);
        this.nextStep();
      } catch (error) {
        message.error("สร้างรายการไม่สำเร็จ กรุณาลองอีกครั้ง");
      }
    },
    async getPrice() {
      try {
        let res = await paymentservice.getPrice(
          this.game.code,
          this.gamePackage.package.id,
          this.gamePackage.playerId,
          this.gamePackage.paymentMethod.code
        );
        this.txtPrice = `${this.gamePackage.package.price + res.data.point * 0.01}`;
        this.randId = res.data.id;
        await this.getTime();
      } catch (error) {
        message.error("ดึงข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      }
    },
    async getTime() {
      let uid = await configuration.getUid();
      var data = {
        RandPointId: this.randId,
        GameId: parseInt(this.gamePackage.gameId),
        PackageId: parseInt(this.gamePackage.package.id),
        PlayerId: this.gamePackage.playerId,
        PlayerName: this.gamePackage.playerName,
        Field1: this.gamePackage.field1,
        Field2: this.gamePackage.field2,
        Field3: this.gamePackage.field3,
        Field4: this.gamePackage.field4,
        Field5: this.gamePackage.field5,
        Uid: uid,
        PaymentMethodName: this.gamePackage.paymentMethod.name,
        PaymentMethodCode: this.gamePackage.paymentMethod.code,
        BankName: this.gamePackage.bank.bankName,
        BankAccount: this.gamePackage.bank.accountNo,
      };

      try {
        let res = await paymentservice.confirmPrice(data);
        this.data = res.data;
        const datares = JSON.stringify(res.data);
        localStorage.setItem("data", datares);
        await this.getConfiguration();
      } catch (error) {
        message.error("สร้างรายการไม่สำเร็จ กรุณาลองอีกครั้ง");
      }
    },
    cancelOrder() {
      this.$router.push("/game");
    },
    async getConfiguration() {
      try {
        let res = await paymentservice.getTimeLimit();
        this.time = res.data.optionValue;
        var dateNow = new Date(res.data.nowDate);
        var generatedTime = new Date(this.data.generatedTime);
        var msec = dateNow - generatedTime;
        var mins = msec / 60000;
        this.timerCount = 60 * (this.time - mins);
      } catch (error) {
        message.error("ดึงเวลาไม่สำเร็จ กรุณาลองอีกครั้ง");
      } finally {
        this.loadedConfig = true;
      }
    },
  },
  watch: {
    timerCount: {
      async handler(value) {
        if (value > 0) {
          setTimeout(() => {
            var minutes = parseInt(value / 60, 10);
            var seconds = parseInt(value % 60, 10);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            this.timers = minutes + ":" + seconds;
            this.timerCount--;
          }, 1000);
        } else {
          this.timers = "00:00";
          this.countErr++;
          if (this.countErr > 300 && this.loadedConfig) {
            try {
              let res = await paymentservice.updateOrderStatus({
                orderNo: this.data.orderNo,
                status: "cancel",
              });
              if (res) {
                localStorage.removeItem("AcceptTerm");
                localStorage.removeItem("GamePackage");
                localStorage.removeItem("data");
                this.isCancel = true;
                message.warn("Order ของคุณถูกยกเลิกเนื่องจากเลยเวลาที่กำหนด");
                this.$router.push("/purchase/history");
              }
            } catch (error) {
              message.warn("Order ของคุณถูกยกเลิกเนื่องจากเลยเวลาที่กำหนด");
            }
          }
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  data() {
    return {
      loadedConfig: false,
      checkboxes: {
        terms: false,
        terms2: false,
      },
      isCancel: false,
      data: null,
      timers: "",
      timerCount: 0,
      countErr: 0,
      gamePackage: {},
      game: {},
      price: 0,
      txtPrice: "0",
      randId: "",
      gameId: "",
      alertText: "ออกจากหน้านี้ คุณต้องการยกเลิกคำสั่งซื้อหรือไม่?",
    };
  },
  async beforeMount() {
    let uid = await configuration.getUid();
    if (uid === "") this.$router.push("/game");
    if (localStorage.getItem("GamePackage") === null) {
      this.$router.push("/game");
    }
    var gamePackage = JSON.parse(localStorage.getItem("GamePackage"));
    this.gamePackage = gamePackage;
    var game = JSON.parse(localStorage.getItem("GameList"));
    this.game = game.find((x) => x.id == gamePackage.gameId);
    if (localStorage.getItem("data") === null) {
      if (gamePackage.paymentMethod.code === "wallet") {
        await this.confirmOrder();
      } else {
        await this.getPrice();
      }
    } else {
      this.data = JSON.parse(localStorage.getItem("data"));
      await this.getConfiguration();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/thankyou") {
      next();
    } else if (this.isCancel) {
      next();
    } else {
      const swal2 = Swal.mixin({
        confirmButtonText: "ใช่",
        cancelButtonText: "ไม่ใช่",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-default",
        },
        buttonsStyling: false,
      });
      swal2
        .fire({
          title: "ยกเลิกคำสั่งซื้อ",
          text: this.alertText,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              let res = await paymentservice.updateOrderStatus({
                orderNo: this.data.orderNo,
                status: "cancel",
              });
              if (res) {
                localStorage.removeItem("AcceptTerm");
                localStorage.removeItem("GamePackage");
                localStorage.removeItem("data");
                next();
              }
            } catch (error) {
              message.error("ไม่สามารถยกเลิก order ได้ กรุณาลองอีกครั้ง");
            }
          } else {
            next(false);
          }
        });
    }
  },
};
</script>

<style>
.card-wizard .tab-content {
  min-height: unset !important;
}

.card-wizard .card-header {
  padding-bottom: 15px !important;
}
.tbtn {
  margin: 5px !important;
}

.payment {
  font-size: 3.5em;
}
</style>
